



















































import { Vue, Component } from 'vue-property-decorator';
import { VueEditor } from 'vue2-editor';
import { vxm } from '@/store.vuex';
import avatar from 'vue-avatar';
import axios from 'axios';
import Multiselect from 'vue-multiselect';
@Component({
  components: {
    avatar,
    VueEditor,
    Multiselect,
  },
})
export default class EditEditor extends Vue {
  private title: String = '';
  private selectedCategory: any = {
    forumCategoryTitle: 'General',
    forumCategoryId: 0,
  };
  private newforumPostData: String = '';
  private postInfo: any = {
    forumPost: String,
    action: String,
    companyCode: String,
    userId: Number,
    title: String,
    categoryId: Number || String,
  };
  $wlToastr: any;

  get customToolbar() {
    return [
      vxm.configs.getGlobalConfigBooelanValue('WL_ENABLE_FORUM_MEDIA_CANDIDATE')
        ? ['image']
        : [],
    ];
  }

  get placeholder() {
    return this.$t('forum-post-placeholder');
  }
  async createPost() {
    if (this.newforumPostData === '') {
      this.$wlToastr('error', this.$t('forum-please-write-a-post'), '');
      return;
    } else {
      //this.postInfo.forumPost =  $('.ql-editor')[0].innerHTML;
      this.postInfo.forumPost = this.newforumPostData;
      this.postInfo.action = 'create';
      this.postInfo.companyCode = vxm.jobs.BrandingInfo.companycode;
      this.postInfo.userId = vxm.users.myUserProfile.userId;
      this.postInfo.title = this.title;
      this.postInfo.categoryId = this.selectedCategory.forumCategoryId;
      const respPromise: any = vxm.forum.createPost(this.postInfo);
      const resp = await respPromise;
      if (resp.success) {
        vxm.users.Rudderstack.trackEvent("Forum Post Created", {
      forumPostId : resp.forumPostResponse.postId
        });
        this.$wlToastr('success', resp.successMessage, '');
        vxm.forum.loadPosts({ initCall: true });
      } else {
        this.$wlToastr('error', resp.errorMessage, '');
      }
      this.postInfo = {};
      this.$bvModal.hide('modal-create-post');
    }
  }

  get categories() {
    return vxm.forum.Categories.filter((category) => {
      return category.restrictedTo !== 1;
    });
  }

  cancelCreateNewPost() {
    this.postInfo = {};
    this.postInfo.action = 'cancel';
    this.$bvModal.hide('modal-create-post');
  }

  handleImageAdded(file, Editor, cursorLocation, resetUploader) {
    var formData = new FormData();
    formData.append('file', file);
    axios({
      url: `/forum/api/v1/posts/uploadimage?companyCode=${
        vxm.jobs.BrandingInfo.companycode
      }`,
      method: 'POST',
      data: formData,
      headers: {
        'app-agent': 'CANDIDATE-PORTAL',
      },
    })
      .then((result) => {
        if (result && result.data && !result.data.success) {
          this.$wlToastr('error', result.data.errorMessage);
          return;
        }
        let url = result.data.imagePath; // Get url from response
        Editor.insertEmbed(cursorLocation, 'image', url);
        resetUploader();
      })
      .catch((e) => {
        if (e && e.response && (e.response.status === 503 || e.response.status === 418)) {
          this.$wlToastr(
            'error',
            this.$t('ResumeDetails_SecurityRisk'),
          );
        }
        if (e && e.response && e.response.data && e.response.data.message) {
          this.$wlToastr('error', e.response.data.message);
        }
      });
  }
}
